import useFeature from "hooks/useFeature";
const useIsInvestigationAIReportEnabled = () => useFeature("investigation_report_by_ai");
export default useIsInvestigationAIReportEnabled;
